import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
const QbankV2Provider = (props) => {
  const api = new API();
  const [QbankV2SpecilityFilter, setQBankV2SpecilityFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [QbankV2SpecilityList, setQBankV2SpecilityList] = useState([]);
  const [QbankV2SpecilityLoader, setQBankV2SpecilityLoader] = useState(false);
  const [QbankV2TopicFilter, setQBankV2TopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [QbankV2TopicList, setQBankV2TopicList] = useState([]);
  const [QbankV2TopicLoader, setQBankV2TopicLoader] = useState(false);
  const [QbankV2SubTopicFilter, setQBankV2SubTopicFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [QbankV2SubTopicList, setQBankV2SubTopicList] = useState([]);
  const [QbankV2SubTopicLoader, setQBankV2SubTopicLoader] = useState(false);
  const [QbankV2QBankFilter, setQBankV2QBankFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [QbankV2QBankList, setQBankV2QBankList] = useState([]);
  const [QbankV2QBankLoader, setQBankV2QBankLoader] = useState(false);

  const fetchQBankV2Specility = async () => {
    setQBankV2SpecilityLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("examsnew/exam_speciality_list_v2", { ...QbankV2SpecilityFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setQBankV2SpecilityList(res?.data?.data);
          setQBankV2SpecilityLoader(false);
        } else {
          setQBankV2SpecilityList([]);
          setQBankV2SpecilityLoader(false);
        }
      });
  }

  const fetchQBankV2Topic = async (subcategory_id=null) => {
    if(!subcategory_id) return;
    setQBankV2TopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("examsnew/exam_topic_list_v2", { ...QbankV2TopicFilter, subcategory_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setQBankV2TopicList(res?.data?.data);
          setQBankV2TopicLoader(false);
        } else {
          setQBankV2TopicList([]);
          setQBankV2TopicLoader(false);
        }
      });
  }

  const fetchQBankV2SubTopic = async (subject_id=null) => {
    if(!subject_id) return;
    setQBankV2SubTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("examsnew/exam_subtopic_list_v2", { ...QbankV2SubTopicFilter, subject_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setQBankV2SubTopicList(res?.data?.data);
          setQBankV2SubTopicLoader(false);
        } else {
          setQBankV2SubTopicList([]);
          setQBankV2SubTopicLoader(false);
        }
      });
  }

  const fetchQBankV2QBank = async (topic_id=null) => {
    if(!topic_id) return;
    setQBankV2QBankLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("examsnew/exam_list_v2", { ...QbankV2QBankFilter, topic_id }, (err, res) => {
        if (res?.data?.status === 200) {
          setQBankV2QBankList(res?.data?.data);
          setQBankV2QBankLoader(false);
        } else {
          setQBankV2QBankList([]);
          setQBankV2QBankLoader(false);
        }
      });
  }

  return (
    <Context.Provider
      value={{
        ...props,
        QbankV2SpecilityFilter, setQBankV2SpecilityFilter,
        QbankV2SpecilityList, setQBankV2SpecilityList,
        QbankV2SpecilityLoader, setQBankV2SpecilityLoader,
        fetchQBankV2Specility,
        QbankV2TopicFilter, setQBankV2TopicFilter,
        QbankV2TopicList, setQBankV2TopicList,
        QbankV2TopicLoader, setQBankV2TopicLoader,
        fetchQBankV2Topic,
        QbankV2SubTopicFilter, setQBankV2SubTopicFilter,
        QbankV2SubTopicList, setQBankV2SubTopicList,
        QbankV2SubTopicLoader, setQBankV2SubTopicLoader,
        fetchQBankV2SubTopic,
        QbankV2QBankFilter, setQBankV2QBankFilter,
        QbankV2QBankList, setQBankV2QBankList,
        QbankV2QBankLoader, setQBankV2QBankLoader,
        fetchQBankV2QBank,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default QbankV2Provider;
